export default `
query customer($orderNumber: String!) {
    customer {
        orders(scope: WEBSITE, filter: { number: { eq: $orderNumber } }) {
            items {
                items {
                    eligible_for_return
                    id
                    product_name
                    product_sku
                    product_type
                    product_url_key
                    quantity_invoiced
                    quantity_ordered
                    quantity_refunded
                    quantity_returned
                    quantity_shipped
                    selected_options {
                        label
                        value
                    }
                    product_sale_price {
                        value
                    }
                    entered_options {
                        label
                        value
                    }
                    product {
                        stock_status
                        canonical_url
                        image {
                            url
                        }
                    }
                }
            }
        }
    }
}
`
